export const DEBOUNCE_TIME_IN_MS = 500;

/**
 * Piwik Pro custom dimension IDs, as configured in the Piwik Pro admin console.
 *
 * These are the globally sequential dimension IDs (NOT the per-scope slots), which is what
 * `setCustomDimensionValue(id, value)` expects.
 */
export const PIWIK_DIMENSION = {
  CUSTOMER_NAME: 1, // Session scope — "CRM Customer Name"
  CUSTOMER_ID: 2, // Session scope — "CRM Customer Id"
  MODULE: 3, // Event scope — "Nwd Module"
} as const;

export const DEFAULT_LANGUAGE = "nl";
export const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE, "en"];
export const LANGUAGE_STORAGE_KEY = "lang";
